import React, { useContext } from 'react';
import { localize } from '/react4xp/mixins/helpers';
import Button from '/react4xp/mixins/ui/button/button';

interface CollapsedButtonProps {
    open: () => void;
    translations: any;
}

const CollapsedButton = ({ open, translations }: CollapsedButtonProps) => {
    return (
        <Button
            onClick={open}
            className="virtual-assistant-toggle-button"
            color="gold"
        >
            <span>{localize('title', translations)}</span>
        </Button>
    );
};

export default CollapsedButton;
